






















import { Component, Prop, Vue } from 'vue-property-decorator'
import Country from '@/dto/deliveries/Country'
import PlaceSelectCount from '@/components/calculator/CalculatorForm/PlaceSelect/PlaceSelectCount.vue'

@Component({
  components: { PlaceSelectCount },
})
export default class PlaceSelectEmptyResult extends Vue {
  @Prop(Object) country: Country
  @Prop(String) query: string
}
